<template>
  <span>
    <v-menu offset-y left>
      <template v-slot:activator="{ on: menu, attrs }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn v-bind="attrs" icon v-on="{ ...tooltip, ...menu }">
              <v-icon>mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>Help</span>
        </v-tooltip>
      </template>
      <v-list dense>
        <v-list-item @click="dialog = true">
          <v-list-item-action><v-icon>mdi-book-open-variant</v-icon></v-list-item-action>
          <v-list-item-title>Quick guide</v-list-item-title>
        </v-list-item>
        <v-list-item to="/examples">
          <v-list-item-action><v-icon>mdi-flask-outline</v-icon></v-list-item-action>
          <v-list-item-title>Ready-to-run examples</v-list-item-title>
        </v-list-item>
        <v-list-item
          href="https://www.notion.so/Ajuda-do-ElectrosFI-cd73ea00c33d4335a8ee1244dac9914c"
          target="_blank"
          rel="noreferrer"
        >
          <v-list-item-action><v-icon>mdi-open-in-new</v-icon></v-list-item-action>
          <v-list-item-title>Full documentation</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <QuickGuideDialog v-model="dialog" />
  </span>
</template>
<script>
export default {
  name: "HelpButton",
  components: {
    QuickGuideDialog: () => import("@/components/QuickGuideDialog")
  },
  data: () => ({
    dialog: false
  })
};
</script>
